export default {
  CHANGE_COLOR_PALETTE: '@WS_EDITOR/WEBSITE_DESIGN/CHANGE_COLOR_PALETTE',
  SWITCH_COLOR_PALETTE: '@WS_EDITOR/WEBSITE_DESIGN/SWITCH_COLOR_PALETTE',
  CHANGE_COLOR: '@WS_EDITOR/WEBSITE_DESIGN/CHANGE_COLOR',
  CHANGE_FONT_PAIRS: '@WS_EDITOR/WEBSITE_DESIGN/CHANGE_FONT_PAIRS',
};
